import AttrHorizontal from './attr_horizontal'
import AttrVertical from './attr_vertical'
import { pickBy } from '@/utils'

export default {
  name: 'marquees',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '標題' },
    { label: '副標題', key: 'subtitle', component: 'input', value: '副標題' },
    { label: '元件間距', key: 'padded', component: 'switch', value: true },
    {
      label: '內容',
      key: 'direction',
      component: 'radio',
      options: [
        { name: '業配文', label: 'vertical' },
        { name: '文字', label: 'horizontal' }
      ],
      value: 'vertical'
    },
    { label: '背景顏色', key: 'bgcolor', component: 'color', value: '#ffffff' },
    { label: '字型顏色', key: 'fontcolor', component: 'color', value: '#000000' },
    {
      label: '文字',
      key: 'dataText',
      isShow: function () {
        return this.value.direction == 'horizontal'
      },
      component: function (h, { key }) {
        return <AttrHorizontal v-model={this.value[key]} />
      },
      value: [{ title: '文字內容' }]
    },
    {
      label: '業配文',
      key: 'dataContent',
      isShow: function () {
        return this.value.direction == 'vertical'
      },
      component: function (h, { key }) {
        return <AttrVertical v-model={this.value[key]} />
      },
      value: [{ title: '業配文標題', id: '' }]
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data } = v
    let res = {
      name,
      ...base,
      ...config
    }
    if (config.direction == 'horizontal') {
      res = {
        ...res,
        dataText: data
      }
    } else {
      res = {
        ...res,
        dataContent: data
      }
    }
    return res

    // dataText: config.direction == 'horizontal' ? data : [{ title: '文字內容' }],
    //   dataContent: config.direction == 'vertical' ? data : [{ title: '業配文標題', id: '' }]
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      config: (v) => {
        return pickBy(v, {
          bgcolor: 'bgcolor',
          direction: 'direction',
          fontcolor: 'fontcolor'
        })
      },
      data: v.direction == 'horizontal' ? v.dataText : v.dataContent
    })
  }
}
